/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Subtitle_Export_Event_Start_After_EndInputs */

const en_subtitle_export_event_start_after_end = /** @type {(inputs: Subtitle_Export_Event_Start_After_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} has a start time greater than its end time.
 Would you like to ABORT your export?`)
};

const fr_subtitle_export_event_start_after_end = /** @type {(inputs: Subtitle_Export_Event_Start_After_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'événement ${i?.index} a une heure de début postérieure à son heure de fin.

Souhaitez-vous annuler l'exportation ?`)
};

const de_subtitle_export_event_start_after_end = /** @type {(inputs: Subtitle_Export_Event_Start_After_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das Ereignis ${i?.index} hat eine Startzeit, die nach der Endzeit liegt.
Möchten Sie den Export abbrechen?`)
};

const it_subtitle_export_event_start_after_end = /** @type {(inputs: Subtitle_Export_Event_Start_After_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'evento ${i?.index} ha un orario di inizio successivo all'orario di fine.
Vuoi ANNULLARE l'esportazione?`)
};

const ru_subtitle_export_event_start_after_end = /** @type {(inputs: Subtitle_Export_Event_Start_After_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index} имеет время начала, превышающее время окончания.
Вы хотите ОТМЕНИТЬ экспорт?`)
};

const es_subtitle_export_event_start_after_end = /** @type {(inputs: Subtitle_Export_Event_Start_After_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El evento ${i?.index} tiene una hora de inicio mayor que su hora de finalización.
¿Desea cancelar la exportación?`)
};

const zh_cn2_subtitle_export_event_start_after_end = /** @type {(inputs: Subtitle_Export_Event_Start_After_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.index} 的开始时间大于结束时间。

是否要中止导出？`)
};

const ja_subtitle_export_event_start_after_end = /** @type {(inputs: Subtitle_Export_Event_Start_After_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index} の開始時刻が終了時刻よりも後になっています。
エクスポートを中止しますか?`)
};

const hi_subtitle_export_event_start_after_end = /** @type {(inputs: Subtitle_Export_Event_Start_After_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.index} का प्रारंभ समय उसके समाप्ति समय से अधिक है।
क्या आप अपना निर्यात रद्द करना चाहेंगे?`)
};

const pt_pt2_subtitle_export_event_start_after_end = /** @type {(inputs: Subtitle_Export_Event_Start_After_EndInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O evento ${i?.index} tem um horário de início posterior ao seu horário de término.
Deseja CANCELAR a exportação?`)
};

/**
* | output |
* | --- |
* | "Event {index} has a start time greater than its end time. Would you like to ABORT your export?" |
*
* @param {Subtitle_Export_Event_Start_After_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_event_start_after_end = /** @type {((inputs: Subtitle_Export_Event_Start_After_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Event_Start_After_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_event_start_after_end(inputs)
	if (locale === "de") return de_subtitle_export_event_start_after_end(inputs)
	if (locale === "it") return it_subtitle_export_event_start_after_end(inputs)
	if (locale === "ru") return ru_subtitle_export_event_start_after_end(inputs)
	if (locale === "es") return es_subtitle_export_event_start_after_end(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_event_start_after_end(inputs)
	if (locale === "ja") return ja_subtitle_export_event_start_after_end(inputs)
	if (locale === "hi") return hi_subtitle_export_event_start_after_end(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_event_start_after_end(inputs)
	return en_subtitle_export_event_start_after_end(inputs)
});